import { FunctionComponent, ReactElement, useContext, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { apiClient } from '../../adapters/api-client';
import { Marital } from '../../adapters/api-client/referential/Referential.model';
import { GenderInput, GenderInputDS, NumericStepper, SelectedButton } from '../../components/DesignSystem';
import { useFetch } from '../../hooks/useFetch';
import { store } from '../../store/store';
import { updateStore } from '../../store/store.actions';
import { FormText } from '../../styles/TypoStyle';
import { ValidityHtmlElement } from '../../utils/DsType';

const Container = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
  width: 100%;
`;

const OptinChildCount = styled(FormText)`
  width: 100%;
`;
const Info = styled.div`
  background-color: rgb(229, 245, 253);
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 30px !important;
  // min-width: 95%;
  font-family: 'Open Sans' !important;
  width: 95%;
  margin-top: 20px;
  @media (max-width: 1024px) {
    width: 100%;
  }
`;
const TextDiv = styled.div`
  font-size: 12px;
  color: #4a4a4a;
  font-family: Helvetica, Arial, sans-serif;
`;
const SituationFamiliale: FunctionComponent<Record<string, never>> = (): ReactElement => {
  const situationRef = useRef<GenderInputDS>(null);
  const {
    state: { familySituation },
    apiStatus,
    dispatch,
  } = useContext(store);
  const onChildrenChange = (e: Event & { currentTarget?: { value?: unknown } | null }) => {
    dispatch(updateStore({ familySituation: { childrenCount: e.currentTarget?.value } }));
  };
  // Fetch Maritals Data
  const { response: maritals } = useFetch(() => apiClient().referential.getMaritals());
  useEffect(() => {
    if (!!situationRef && situationRef.current !== null) {
      situationRef.current.value = familySituation?.maritalStatusCode || '';
    }
  }, [apiStatus]);

  // on situation change
  const onSituationChange = (e: Event & { currentTarget?: { value?: unknown } | null }) => {
    if (!!situationRef && situationRef.current !== null) {
      (situationRef.current as unknown as ValidityHtmlElement).assignValidity();
      dispatch(updateStore({ familySituation: { maritalStatusCode: e.currentTarget?.value } }));
    }
  };
  return (
    <>
      <GenderInput
        ref={situationRef}
        class="to-validate trackable-click"
        label="Situation familiale"
        data-id="maritalStatusCode"
        onSelectedElementChange={onSituationChange}
        value={familySituation?.maritalStatusCode}
        error-message="Veuillez choisir votre situation familiale."
      >
        {maritals &&
          maritals.map(({ code, label }: Marital) => (
            <SelectedButton id={code} value={code} secondary>
              {label}
            </SelectedButton>
          ))}
      </GenderInput>
      <Container>
        <OptinChildCount>Nombre d'enfants fiscalement à charge</OptinChildCount>
        <NumericStepper
          onStepperChanged={onChildrenChange}
          value={familySituation?.childrenCount}
          max-value="9"
          min-value="0"
        ></NumericStepper>
      </Container>
      <Info>
        {/* <IconDiv className="columns small-1 large-1 medium-1 padding-left-reduce">
            <div className="i-icon"></div>
          </IconDiv> */}
        <TextDiv>
          <span>Ou autre personne à charge de plus de 16 ans. Prendre en compte les membres du foyer fiscal.</span>
        </TextDiv>
      </Info>
    </>
  );
};

export default SituationFamiliale;
